export const notificationState = {
  inviteRequestCount: 0,
  notificationCount: null,
  unreadInviteRequestCount: null,
  userId: 0,
  hasOrganizationPrivacyUpdate: null,
};
